import { mergeObjects } from "utils";
import { DEFAULT_PREBID_BIDDER_SETTINGS } from "../../config/prebid";

export class PrebidWrapper {
  private prebidReady: boolean = false;
  private readonly pbjs: Exclude<typeof window.pbjs, undefined>;

  constructor(private readonly prebidConfig: PrebidConfig) {
    window.pbjs = window.pbjs ?? ({} as Prebid);
    window.pbjs.que = window.pbjs.que ?? [];

    this.pbjs = window.pbjs;

    this.pbjs.que.push(() => {
      this.pbjs.bidderSettings = mergeObjects(
        this.pbjs.bidderSettings,
        DEFAULT_PREBID_BIDDER_SETTINGS,
      ) as PrebidBidderSettings;

      this.pbjs.setConfig({
        ...this.prebidConfig,
      });

      this.prebidReady = true;
    });
  }

  isPrebidReady(): boolean {
    return this.prebidReady;
  }

  defineAdUnits(adUnits: PrebidAdUnit[]) {
    this.pbjs.que.push(() => {
      this.pbjs.addAdUnits(adUnits);
    });
  }

  requestBids(prebidRequest: PrebidRequest) {
    this.pbjs.que.push(() => {
      this.pbjs.requestBids(prebidRequest);
    });
  }

  setTargetingForGPTAsync(
    adUnitCodes?: string[],
    customSlotMatching?: (
      slot: googletag.Slot,
    ) => (adUnitCode: string) => boolean,
  ) {
    this.pbjs.que.push(() => {
      this.pbjs.setTargetingForGPTAsync?.(adUnitCodes, customSlotMatching);
    });
  }

  pushToQueue(fn: (pbjs: Prebid) => void) {
    this.pbjs.que.push(() => fn(this.pbjs));
  }
}
